import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import Footer from "../components/Footer/Footer";
import backgroundImg from "../assets/login-bg.png";
import HeaderMenu from "../components/HeaderMenu/HeaderMenu";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ForgetPasswordRequest } from "../interfaces/models/ForgetPasswordRequest";
import { ForgetPasswordCall } from "../apis/EpendisisApi";

const ForgetPassword: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [alertVisibility, setAlertVisibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = location.pathname.split('/').pop();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    switch (name) {
      case "password":
        setPassword(value);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    document.title = "Forget Password";
  }, [location]);

  const isPasswordValid = (password: string) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
    return passwordRegex.test(password);
  };

  const handleApiCall = async () => {
    try{
      const response = await ForgetPasswordCall(new ForgetPasswordRequest(password, code ?? ''))
      navigate('/login');
    }
    catch(error){
      setErrorMsg("Something went wrong");
      setAlertVisibility(true);
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isPasswordValid(password)) {
      handleApiCall();
    } else {
      setErrorMsg(
        "Password must be at least 8 characters long and contain both letters and numbers."
      );
      setAlertVisibility(true);
    }
  };

  return (
    <Container
      fluid
      className="wrapper"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: "0",
      }}
    >
      <div
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          display: "grid",
          flexDirection: "column",
          paddingBottom: "5%",
        }}
      >
        <HeaderMenu />
        <Container style={{ flex: "1", marginTop: "3%" }}>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <div
                className="login-signup-div"
                style={{
                  backgroundColor: "white",
                  padding: "30px",
                  borderRadius: "10px",
                  paddingLeft: "15%",
                  paddingRight: "15%",
                }}
              >
                {alertVisibility && (
                  <Alert
                    variant="danger"
                    onClose={() => setAlertVisibility(false)}
                    dismissible
                  >
                    {errorMsg}
                  </Alert>
                )}
                <Row>
                  <h2 className="text-center">Reset Your Password</h2>
                  <p className="text-center">
                    Password must be at least 8 characters long and contain both
                    letters and numbers.
                  </p>
                </Row>
                <Form onSubmit={handleSubmit}>
                  <Form.Group
                    controlId="formBasicPassword"
                    style={{ marginBottom: "25px" }}
                  >
                    <Form.Control
                      className="text-center login-signup-input"
                      type="password"
                      placeholder="New Password"
                      value={password}
                      name="password"
                      onChange={handleInputChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Password must be at least 8 characters and contain both
                      letters and numbers.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="login-signup-button"
                    disabled={loading}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: "5px" }}
                        />
                        &nbsp; Loading...
                      </>
                    ) : (
                      "Reset"
                    )}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container
        fluid
        className="justify-content-center"
        style={{
          marginTop: "1%",
          padding: "1%",
          backgroundColor: "white",
          width: "100%",
          bottom: "0",
        }}
      >
        <Footer />
      </Container>
    </Container>
  );
};

export default ForgetPassword;
